<div class="bmc-sync-data__wrapper">

  <div class="bmc-syncdata-import-step2" [ngClass]="messageToUser ? 'bmc-syncdata-import-step2--error' : ''">
    <div class="bmc-syncdata-import-step2__header">
      <h4 class="bmc-syncdata-import-step2__header__title">{{'SYNC_DATA.VIEW_LOG' | translate}}</h4>
      <label class="bmc-syncdata-import-subtitle">{{'SYNC_DATA.CHOOSE_ENTITIES_DO_YOU_NEED_TO_IMPORT' | translate}}</label>
    </div>
    <div class="bmc-syncdata-import-step2__container">
      <div class="bmc-syncdata-import-step2__container__list">
        <div class="bmc-syncdata-import-step2__entity__header">
          <h4 class="bmc-syncdata-import-step2__entity__header__title">
            {{ 'SYNC_DATA.SELECTED_ENTITY_VALUES' | translate}}
          </h4>
        </div>
        <div class="bmc-syncdata-import-step2__search-box">

          <svg class="bz-icon-svg bz-icon-svg--16 bmc-syncdata-import-step2__search-box__icon">
            <use href="#icon-search"></use>
          </svg>
          <input #filter class="bmc-syncdata-import-step2__search-box__text" type="text" placeholder="{{ 'SYNC_DATA.SEARCH' | translate}}" (input)="onSearchChange(filter.value)">
        </div>
        <ul class="bmc-syncdata-import-step2__entity__list">
          <li class="bmc-syncdata-import-step2__entity__item" (click)="onTableSelected(item);"  *ngFor="let item of selectedTables" [ngClass]="item.SelectedUI ? 'bmc-syncdata-import-step2__entity__item--selected' : ''">
            <label [ngClass]="hasErrors(item) ? 'tableHighlighted' : 'tableNoHighlighted'">{{item.DisplayName}}</label>
          </li>
        </ul>
      </div>
      <div class="bmc-syncdata-import-step2__container__detail">
        <table class="bmc-syncdata-import-step2__result">
          <thead>
          <tr class="bmc-syncdata-import-step2__result__header">
            <th>&nbsp;{{ 'SYNC_DATA.TYPE' | translate}}&nbsp;</th>
            <th>{{ 'SYNC_DATA.MESSAGE' | translate}}</th>
            <th>&nbsp;{{ 'SYNC_DATA.APPROVE' | translate}}&nbsp;</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let issue of filteredIssues; let i = index" class="bmc-syncdata-import-step2__result__item">
            <td style="text-align: center;">
              <svg class="bz-icon-svg bz-icon-svg--16 bmc-syncdata-import-step2__item-icon" [ngClass]=" {
              'bmc-syncdata-import-step2__item-icon--error': issue.Type === 2,
            'bmc-syncdata-import-step2__item-icon--warning': issue.Type === 1,
            'bmc-syncdata-import-step2__item-icon--info': issue.Type === 0
              }">
                <use href="#icon-warning" *ngIf="issue.Type === 1"></use>
                <use href="#icon-stop" *ngIf="issue.Type === 2"></use>
                <use href="#icon-info" *ngIf="issue.Type === 0"></use>
              </svg>
            </td>
            <td class="bmc-syncdata-import-step2__result__item__cell">{{issue.Message}}</td>
            <td style="text-align: center;" class="bmc-syncdata-import-step2__result__item__approve">
              <div class="bz-checkbox" *ngIf="issue.Type === 1">
                <bzg-checkbox id="check-{{issue.IssueKey}}" [checked]="issue.AuthorizedByUser" (click)="selectWarning(i, $event)">
                </bzg-checkbox>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div *ngIf="showSendMailCheckbox" class="bmc-syncdata-import-step2__send-mail">
      <p class="bmc-syncdata-import-step2__send-mail__text">{{'SYNC_DATA.SEND_MAIL_MESSAGE' | translate }}</p>
      <div class="bz-checkbox">
        <bzg-checkbox id="checkSendEmail" [checked]="data.syncData.EnabledMail" (click)="changeEmail($event)">
          &nbsp;{{ 'SYNC_DATA.IMPORT_STEP20_SEND_EMAIL' | translate}}
        </bzg-checkbox>
      </div>
    </div>
    <div *ngIf="messageToUser" class="bmc-sync-data__error">
      <svg class="bz-icon-svg bz-icon-svg--16 bmc-sync-data__error__icon">
        <use href="#icon-warning"></use>
      </svg>
      <label class="bmc-sync-data__error__label">{{ messageToUser | translate}}</label>
    </div>
  </div>
  <div  *ngIf="isLoading"  class="bmc-sync-data__loader">
      <bounce>
        {{'SYNC_DATA.VALIDATING_IMPORTED_DATA' | translate}}
      </bounce>
    </div>
</div>
